/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MySvgControllerService } from './services/my-svg-controller.service';
import { FuelCardOrderControllerService } from './services/fuel-card-order-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MySvgControllerService,
    FuelCardOrderControllerService,
    ApiConfiguration
  ],
})
export class FuelCardModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<FuelCardModule> {
    return {
      ngModule: FuelCardModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: FuelCardModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('FuelCardModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
